<script lang="ts">
	import { P, Popover } from 'flowbite-svelte';

	/** Convenience prop — equivalent to filling the `header` slot with plain text. */
	export let title: string = '';
	/** Convenience prop — equivalent to filling the `description` slot. */
	export let description: string = '';

	$: hasHeaderSlot = $$slots.header;
	$: hasDescriptionSlot = $$slots.description;
	$: hasHelpSlot = $$slots.help;
</script>

<!-- `pageHeader` draws the accent underline (see app.postcss). The inner `h1` is
     the page's real heading — app.postcss suppresses its own `h1::after` inside
     a `.pageHeader` so the underline isn't drawn twice. -->
<div class="pageHeader text-2xl font-bold mb-6">
	<div class="flex items-center">
		<h1 class="flex-none text-2xl font-bold text-gray-900 dark:text-white mr-4">
			{#if hasHeaderSlot}
				<slot name="header" />
			{:else}
				{title}
			{/if}
		</h1>
		<div class="grow" />
		{#if hasHelpSlot}
			<div class="text-2xl">
				<div class="cursor-help text-blue-600 dark:text-blue-400 hover:text-primary-500">
					<i class="fa-solid fa-circle-question" />
				</div>
				<Popover color="dropdown" class="w-96 shadow-2xl shadow-blue-800 text-base font-normal z-30" placement="bottom">
					<slot name="help" />
				</Popover>
			</div>
		{/if}
	</div>
</div>

{#if hasDescriptionSlot || description}
	<P class="font-semibold leading-normal text-base text-gray-600 dark:text-gray-400 w-full pb-4 empty:pb-0">
		{#if hasDescriptionSlot}
			<slot name="description" />
		{:else}
			{description}
		{/if}
	</P>
{/if}
